export default "__VITE_PUBLIC_ASSET__44ba6b3d__"